<!-- Mobile sidebar toggle button -->
<button
  class="sidebar-mobile-toggle"
  [class.sidebar-mobile-toggle--open]="mobileSidebarOpen"
  (click)="mobileSidebarOpen = !mobileSidebarOpen"
  aria-label="Toggle sidebar"
>
  <ng-icon [name]="'featherMenu'" [size]="'20'"></ng-icon>
</button>

<!-- Mobile backdrop overlay -->
<div
  class="sidebar-backdrop"
  *ngIf="mobileSidebarOpen"
  (click)="mobileSidebarOpen = false"
></div>

<!-- Sidebar container -->
<aside class="sidebar" [class.sidebar--open]="mobileSidebarOpen">

  <!-- Logo -->
  <div class="sidebar__logo">
    <app-nav-logo></app-nav-logo>
  </div>

  <!-- Navigation -->
  <nav class="sidebar__nav">
    <!-- Main section -->
    <div class="sidebar__group">
      <p class="sidebar__group-label">Main</p>
      <ul class="sidebar__menu">
        <li *ngIf="!rolesAppService.installerRole">
          <app-nav-item routerLink="invoices/list" icon="featherFileText">
            Invoices & Proposals
          </app-nav-item>
        </li>
        <li *ngIf="!rolesAppService.installerRole">
          <app-nav-item routerLink="order/list" icon="featherClipboard">
            Order Forms
          </app-nav-item>
        </li>
        <li>
          <app-nav-item routerLink="installations/list" icon="featherTool">
            Installations
          </app-nav-item>
        </li>
      </ul>
    </div>

    <!-- Finance section -->
    <div class="sidebar__group" *ngIf="rolesAppService.adminRole">
      <p class="sidebar__group-label">Finance</p>
      <ul class="sidebar__menu">
        <li>
          <app-nav-item routerLink="billing/vendors" icon="featherDollarSign">
            Vendors
          </app-nav-item>
        </li>
        <li>
          <app-nav-item routerLink="billing/bills" icon="featherFileText">
            Bills & AP
          </app-nav-item>
        </li>
      </ul>
    </div>

    <!-- Admin section -->
    <div class="sidebar__group" *ngIf="!rolesAppService.limitedRole">
      <p class="sidebar__group-label">Admin</p>
      <ul class="sidebar__menu">
        <li>
          <app-nav-item routerLink="settings" icon="featherSettings">
            Settings
          </app-nav-item>
        </li>
        <li>
          <app-nav-item routerLink="admin/users" icon="featherUsers">
            Users
          </app-nav-item>
        </li>
      </ul>
    </div>
  </nav>

  <!-- Footer / User section -->
  <div class="sidebar__footer">
    <p class="sidebar__group-label">User</p>
    <ul class="sidebar__menu">
      <li>
        <div class="sidebar__user-info">
          <ng-icon name="featherUser" size="18" class="sidebar__user-icon"></ng-icon>
          <span class="sidebar__user-name">{{ (user$ | async)?.name || '' }}</span>
        </div>
      </li>
      <li>
        <app-nav-item icon="featherLogOut" (click)="logout()">
          Logout
        </app-nav-item>
      </li>
    </ul>
  </div>
</aside>
